import store from './CreateStore'

export default store
